import { inject, injectable } from "@launchtray/tsyringe-async";
import { Viewable } from "../../../../../scene/viewable/Viewable";
import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { PromiseCompletionSource } from "../../../../../shared/async/PromiseCompletionSource";
import { WalletConnectMessagesView } from "./view/WalletConnectMessagesView";
import { WalletConnectState } from "./WalletConnectState";
import { ExternalWalletType } from "../../../../../web3/externalWallets/ExternalWalletType";

export type WalletConnectMessageOptions<T extends WalletConnectState> = {
    state: T,
    walletType?: T extends WalletConnectState.CONNECTED ? ExternalWalletType : never
};

@injectable()
export class WalletConnectMessagesScene extends Viewable<void> {
    public constructor(
        commonResources: CommonResourcesPackage,
        @inject("WalletConnectMessageOptions") options: WalletConnectMessageOptions<WalletConnectState>,
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler
    ) {
        super();
        const pcs = new PromiseCompletionSource<void>();
        this.view = new WalletConnectMessagesView(pcs, commonResources, options, canvasScaler);
        pcs.result.then(() => {
            this.operationControls.complete();
        }, (reason: unknown) => {
            this.operationControls.error(reason);
        });
    }
}